export default __webpack_public_path__ + "static/logo-doodad-29be3ecf76eabc767a1f1256e1abddc3.png";